// packages/shared/src/config/runtimeEnv.js

const KEY = '__MSDB_RUNTIME_ENV__';

function store() {
  // globalThis works in browser, electron, node, react-native
  if (!globalThis[KEY]) {
    globalThis[KEY] = {};
  }
  return globalThis[KEY];
}

export function setRuntimeEnvVar(name, value) {
  if (!name) return;
  if (value === undefined || value === null || value === '') return;

  const s = store();
  s[name] = value;

  // optional debug:
  // console.log("SET RUNTIME", name, value);
}

export function getRuntimeEnvVar(name) {
  if (!name) return undefined;
  const s = store();
  return s[name];
}

export function clearRuntimeEnvVar(name) {
  if (!name) return;
  const s = store();
  delete s[name];
}
